import { Search } from 'lucide-react';
import { Input } from '../ui/Input';
import type { LeadStatus } from '../../services/api';

const STATUS_OPTIONS: Array<{ value: LeadStatus | undefined; label: string }> = [
  { value: undefined, label: 'Tutti' },
  { value: 'NEW', label: 'Nuovi' },
  { value: 'CONTACTED', label: 'Contattati' },
  { value: 'INTERESTED', label: 'Interessati' },
  { value: 'NOT_INTERESTED', label: 'Non int.' },
  { value: 'CONVERTED', label: 'Convertiti' },
];

interface LeadFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: LeadStatus | undefined;
  onStatusChange: (status: LeadStatus | undefined) => void;
}

export function LeadFilters({ search, onSearchChange, status, onStatusChange }: LeadFiltersProps) {
  return (
    <div className="space-y-3">
      {/* Search bar */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          placeholder="Cerca per nome, telefono, email..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10 h-10"
        />
      </div>

      {/* Status pills */}
      <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1">
        {STATUS_OPTIONS.map((option) => (
          <button
            key={option.label}
            type="button"
            onClick={() => onStatusChange(option.value)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap flex-shrink-0 ${
              status === option.value
                ? 'bg-blue-500 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
